import React, { useEffect, useRef, useState } from 'react';
import {
  AccordionContent,
  AccordionItems,
  AccordionSection,
  AccordionTitle,
  RotateIcon,
} from './assets/styles/styles';

import arrowRight from './assets/images/arrow.png';

const Accordion = (props) => {
  const [active, setActive] = useState(props.expended || false);
  const contentRef = useRef(null);
  const { hideBar = false } = props;

  useEffect(() => {
    contentRef.current.style.maxHeight = active
      ? `${contentRef.current.scrollHeight}px`
      : '0px';
  }, [contentRef, active]);

  const toggleActive = () => {
    setActive(!active);
  };

  return (
    <AccordionSection>
      <AccordionTitle
        onClick={() => {
          if (!props.noChild) toggleActive();
        }}
      >
        <div className={`title `}>
          <p style={{ textTransform: 'uppercase' }}>{props.title}</p>
        </div>
        <RotateIcon active={active} src={arrowRight}></RotateIcon>
      </AccordionTitle>

      <AccordionContent ref={contentRef} hideBar={hideBar} active={active}>
        <AccordionItems>{props.children}</AccordionItems>
      </AccordionContent>
    </AccordionSection>
  );
};

export default Accordion;
